import { TranslateService } from '@ngx-translate/core';
import { TabService } from '@core/services/tab.service';

/**
 * Localized base name (no extension) for an Excel export triggered from a routed screen.
 *
 * Reads the current tab's `tabTitle` — the same key every route already declares for its
 * tab label, so it's guaranteed to be a real, registered translation key — instead of each
 * screen's own `endpointConfig.name` / `exportFileName`, which are often untranslated
 * identifiers or hardcoded literals that never change with the selected language.
 */
export function exportFileBaseName(translate: TranslateService, tabService: TabService, fallback: string): string {
  const title = tabService.currentTab()?.title;
  return translate.instant(title ?? fallback);
}
